module.exports = __webpack_public_path__ + "static/media/close-circle-outlined.b079c10b.svg";